import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  abierto: boolean;
  titulo: string;
  descripcion?: string;
  onCerrar: () => void;
  children: React.ReactNode;
  acciones?: React.ReactNode;
  ancho?: 'sm' | 'md' | 'lg';
}
export function Modal({
  abierto,
  titulo,
  descripcion,
  onCerrar,
  children,
  acciones,
  ancho = 'md'
}: ModalProps) {
  const contenedor = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!abierto) return;
    const anterior = document.activeElement as HTMLElement | null;
    const foco = contenedor.current?.querySelector<HTMLElement>('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    foco?.focus();
    const alPresionar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCerrar();
      if (e.key === 'Tab' && contenedor.current) {
        const focusables = Array.from(contenedor.current.querySelectorAll<HTMLElement>('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
        if (focusables.length === 0) return;
        const primero = focusables[0];
        const ultimo = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === primero) {
          e.preventDefault();
          ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
          e.preventDefault();
          primero.focus();
        }
      }
    };
    document.addEventListener('keydown', alPresionar);
    return () => {
      document.removeEventListener('keydown', alPresionar);
      anterior?.focus?.();
    };
  }, [abierto, onCerrar]);
  if (!abierto) return null;
  const anchos = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl'
  };
  return <div className="no-imprimir fixed inset-0 z-50 flex items-end justify-center bg-[#421213]/80 p-0 sm:items-center sm:p-4" data-id="element-420" data-mp="1gevl419b6oa2">
      <div ref={contenedor} role="dialog" aria-modal="true" aria-label={titulo} className={`flex max-h-[92vh] w-full ${anchos[ancho]} flex-col overflow-hidden rounded-t-2xl bg-white sm:rounded-2xl`} data-id="element-421" data-mp="1khrvx5slxg3g">
        <div className="flex items-start justify-between gap-4 border-b border-linea px-5 py-4" data-id="element-422" data-mp="3dc16m7lv5j0j">
          <div data-id="element-423" data-mp="38ehmws6ece17">
            <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-424" data-mp="38f10jwp0kg9f">{titulo}</h2>
            {descripcion && <p className="mt-1 text-sm text-tinta-sec" data-id="element-425" data-mp="9urfy498y3h4">{descripcion}</p>}
          </div>
          <button type="button" onClick={onCerrar} aria-label="Cerrar" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-tinta-sec hover:bg-vino/5 hover:text-vino" data-id="element-426" data-mp="4wpu5bkfrq1y">
            <X className="h-5 w-5" aria-hidden="true" data-id="element-427" data-mp="3s41p3jrzao09" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4" data-id="element-428" data-mp="2km10k5fmlzw3">{children}</div>
        {acciones && <div className="flex flex-wrap justify-end gap-2 border-t border-linea bg-lienzo px-5 py-4" data-id="element-429" data-mp="2gomu2ljby67s">
            {acciones}
          </div>}
      </div>
    </div>;
}